<template>
  <div class="one-year-promotion-flow" v-if="!asyncLoading">
   <one-year-promotion-payment v-if="isPayment" :done="goToDone" :action="goToHome"/>
   <one-year-promotion-done v-else :payment-info="paymentInfo"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { hardRefresh } from '@/router';
import Segment from '@/Segment';
import OneYearPromotionPayment from './OneYearPromotionPayment.vue';
import OneYearPromotionDone from './OneYearPromotionDone.vue';

export const ONE_YEAR_PROMOTION_STEPS = {
  payment: 'payment',
  done: 'done',
};

export default {
  name: 'OneYearPromotionFlow',
  components: {
    OneYearPromotionDone,
    OneYearPromotionPayment,
  },
  data() {
    return {
      asyncLoading: true,
      flowStep: null,
      paymentInfo: null,
    };
  },
  computed: {
    isPayment() {
      return this.flowStep === ONE_YEAR_PROMOTION_STEPS.payment;
    },
  },
  async created() {
    Segment.trackUserGot('OneYearPromotionFlow_Entered');

    this.asyncLoading = false;
    this.flowStep = ONE_YEAR_PROMOTION_STEPS.payment;
  },
  methods: {
    ...mapActions('subscription', ['fetchPricing', 'fetchCreditCardMask', 'fetchSubscription']),
    ...mapActions('subscriptionState', ['fetchSubscriptionState']),
    async goToDone(paymentMethodInfo = null) {
      this.paymentInfo = paymentMethodInfo;

      await this.fetchSubscription();
      await this.fetchSubscriptionState();
      this.flowStep = ONE_YEAR_PROMOTION_STEPS.done;
    },
    async goToHome() {
      hardRefresh('/account-settings');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
